import React, { useMemo, useEffect } from 'react';
import { List, Item, Description, NotResults } from './styled';
import { DataListModel } from './DataListModel';

interface Props {
  dataList: DataListModel[];
  handleClickItem?: Function;
  handleRefItems?: Function;
  showFirstItems?: number;
  handleKeyDown?: Function;
  message?: boolean;
}

export const PredictiveResults: React.FC<Props> = ({
  dataList,
  handleClickItem,
  handleRefItems,
  showFirstItems,
  handleKeyDown,
  message
}) => {

  const refSuggestionsList = useMemo(
    () => Array.from({ length: dataList.length }).map(() => React.createRef()),
    [dataList.length]
  );
  const getText = (ubigeo: string) => ubigeo ? `, ${ubigeo}` : '';

  useEffect(() => {
    handleRefItems(refSuggestionsList);
  });

  const createElement = (district?: string, province?: string, department?: string) => {
    const element =  `<p><span>${district}</span>${getText(province)}${getText(department)}</p>`;
    return element;
  };

  const setUrbanizationOrDistrict = (data) => {
    const initial = data.id.charAt(0);
    if (initial === 'D') {
      return data.district_name
    }
    return data.urbanization_name
  };

  const setDistrictOrProvince = (data) => {
    const initial = data.id.charAt(0);
    if (initial === 'D') {
      return data.province_name
    }
    return data.district_name
  };

  return (
    <List showFirstItems={showFirstItems} onKeyDown={handleKeyDown}>
      {
        dataList && dataList.length > 0 && dataList.map((element, index) => (
          <Item
            key={index}
            ref={refSuggestionsList[index]}
            data-index={index}
            tabIndex="-1"
            onMouseDown={() => handleClickItem && handleClickItem(index)}
          >
            <Description
              dangerouslySetInnerHTML={
                {
                  __html: createElement(
                    setUrbanizationOrDistrict(element.data),
                    setDistrictOrProvince(element.data),
                    element.data.department_name
                  )
                }
              } />
          </Item>
        ))
      }
      { message && <NotResults dangerouslySetInnerHTML={{
                      __html: 'No se encontraron resultados.'
                    }} />}
    </List>
)};

PredictiveResults.defaultProps = {
  showFirstItems: 2
}
